export default __webpack_public_path__ + "static/RHR Mobile App Icon-4adbf9fe7e17f45779efce0f85237813.png";